import type { GameDescriptor } from '@everyturn/engine/runtime';

export const spadesDescriptor = {
  gameId: 'spades',
  displayName: 'Spades',
  seats: ['north', 'east', 'south', 'west'],
  seatTeams: { north: 'North / South', south: 'North / South', east: 'East / West', west: 'East / West' },
  minPlayers: 4,
  maxPlayers: 4,
  defaultSeat: 'south',
  layoutId: 'spades',
  discovery: {
    summary:
      'Bid your partnership contract with spades always trump. Make your combined bid, avoid 10 bags, or risk a Nil.',
    family: 'Partnership Trick-Taking',
    playerLabel: '4 Players (2v2)',
    formatLabel: 'To 500 pts',
  },
} as const satisfies GameDescriptor;
